export class CashierManagementDeposit {
    financialAccountId: string;
    date?: Date;
    value: number;

    constructor() {
        this.financialAccountId = '';
        this.date = null;
        this.value = 0;
    }
}
